import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useStateValue } from '../../Contexto/store';
import Config from '../../Configuracion/Configuraciones';
import RutasComponente from '../../Configuracion/RutaComponentes';


// se indica que va tomar el componente que se le envie y todo lo que el traiga 
// Propiedades etc etc 
const RutaSegura = ({ component: Component, ...rest }) => {
    // se accede a la variable de sesion de usuario del storage para luego saber si el usuario esta logueado 
    const [{ sesionUsuario }] = useStateValue();

    //se renderiza todo lo que traiga la ruta original con el ... rest
    //1 - Se revisa si el usuario o la sesion de storage no es nula
    //2 - Se evalua si el usuario esta o no autenticado 
    return (
        <Route
            {...rest}
            render={(props) =>
                sesionUsuario ? (
                    sesionUsuario.autenticado === true ? (
                        <Component {...props} {...rest} />
                    )
                        : <Redirect to={Config.rutaPublicacion + RutasComponente.RutaLogin.path} />
                ) : <Redirect to={Config.rutaPublicacion + RutasComponente.RutaLogin.path} />
            }
        />
    );

};

export default RutaSegura;